<ul class="navbar-nav">
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" aria-haspopup="true"
       aria-expanded="false" ngbDropdownToggle>
      <i class="material-icons notranslate">language</i>
      <p style="display: inline; font-weight: 500;">{{languageHelper.getCurrentLang() | uppercase}}</p>
    </a>
    <div class="dropdown-menu dropdown-menu-right sidebar-language-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
      <a *ngFor="let lang of languageHelper.getFilteredMenuLangs()" (click)="changeLanguage(lang)" class="dropdown-item sidebar-language-dropdown-item">
        <div style="position: relative; top: 2px;">
                <span class="flag-wrapper">
                  <span class="flag flag-background {{languageHelper.languagesMap.get(lang).flagClass}}"></span>
                </span>
          <p style="display: inline; top: -4.5px; position: relative; margin-left: 12px; font-weight: 500;">{{ languageHelper.languagesMap.get(lang).completeName }}</p>
        </div>
      </a>
    </div>
  </li>
</ul>
